import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import Check from '../assets/icons/Check';
import HomeIcon from '../assets/icons/Home';
import ControllerTextInput from '../../SharedComponents/formComponents/baseFormComponents/ControllerTextInput';
import api from '../../../api';

const StepFour = ({ data,control, onNext }) => {
  const navigate = useNavigate();
  const { getValues, setValue } = useForm();
  const [error, setError] = useState('');

  const goToOffer = async () => {
    const pass = getValues('password');

    if (!pass) {
      setError('Polje je obavezno!');
      return;
    }

    setError('');
    try {
      await api.post('/onboarding/set-password', {
        email:data.email,
        password: pass,
      });
 
      onNext({ pass });
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error) {
        setError(err.response.data.error);
      } else {
        setError('Greška pri kreiranju naloga. Pokušaj ponovo.');
      }
    }
  };

  const goToHome = () => {
    navigate('/onboarding');
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>
        Tvoj zahtev je poslat! Poslaćemo ponude u roku od 24h na tvoj email.
      </h2>

      <p style={styles.subtitle}>
        Napravi nalog da bi lako pregledao ponude kupaca i koristio sve mogućnosti SmartPart aplikacije:
      </p>

      <div style={styles.inputGroup}>
        <ControllerTextInput
          name="password"
          control={control}
          placeholder="Upiši šifru da kreiraš nalog"
          onChange={(e) => setValue('password', e.target.value)}
          width={258}
          styleForInput={{
            padding: '12px 16px',
            borderRadius: 6,
            border: '1px solid #787878',
            color: 'white',
            fontSize: '16px',
          }}
        />
        <button onClick={goToOffer} style={styles.button}>
          <span style={styles.buttonText1}>Napravi nalog</span>
          <Check />
        </button>
        {error && <p style={styles.error}>{error}</p>}
      </div>

      <button onClick={goToHome} style={styles.homeButton}>
        <span style={styles.buttonText2}>Naslovna strana</span>
        <HomeIcon />
      </button>
    </div>
  );
};

export default StepFour;

const styles = {
  container: {
    margin: '0 auto',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
  title: {
    fontSize: '34px',
    lineHeight: '42px',
    marginBottom: 20,
  },
  subtitle: {
    fontSize: '16px',
    lineHeight: '24px',
    color: 'white',
    marginBottom: 20,
  },
  inputGroup: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: 12,
    marginBottom: '450px',
  },
  button: {
    padding: '12px 24px',
    backgroundColor: '#d3e205',
    color: '#0f0f0f',
    fontWeight: 'bold',
    border: 'none',
    borderRadius: 6,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  homeButton: {
    padding: '10px 20px',
    border: '2px solid #d3e205',
    color: '#d3e205',
    fontSize: 20,
    backgroundColor: 'transparent',
    borderRadius: 6,
    cursor: 'pointer',
    marginBottom: '20px',
  },
  buttonText1: {
    opacity: 0.99,
    color: '#171718',
    fontSize: '20px',
    fontWeight: 700,
    fontStyle: 'bold',
    letterSpacing: '0.2px',
    textAlign: 'center',
    lineHeight: '20px',
  },
  buttonText2: {
    opacity: 0.99,
    color: 'rgba(211, 226, 5, 1)',
    fontSize: '20px',
    fontWeight: 700,
    fontStyle: 'bold',
    letterSpacing: '0.2px',
    textAlign: 'center',
    lineHeight: '20px',
  },
  error: {
    color: 'white',
    marginTop: 20,
  },
};
